/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Invalidphone1Inputs */

const he_profile_errors_invalidphone1 = /** @type {(inputs: Profile_Errors_Invalidphone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר טלפון לא תקין`)
};

const en_profile_errors_invalidphone1 = /** @type {(inputs: Profile_Errors_Invalidphone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid phone number`)
};

/**
* | output |
* | --- |
* | "Invalid phone number" |
*
* @param {Profile_Errors_Invalidphone1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_errors_invalidphone1 = /** @type {((inputs?: Profile_Errors_Invalidphone1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Invalidphone1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_errors_invalidphone1(inputs)
	return en_profile_errors_invalidphone1(inputs)
});
export { profile_errors_invalidphone1 as "profile_errors_invalidPhone" }